import React from 'react'
//import PropTypes from 'prop-types'

export default class PageHeader extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      header: "page header",
      subtext: "subtext form header"
    }
  }

  render(){
    return (
      <div className="page-header">
        <h1>Example page header <small>Subtext for header</small></h1>
      </div>
    )
  }
} 



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/PageHeader.js